import projection from '../generated/pwc204f1.json';
import { AcceptanceManifest } from '../types';

export const pwc204f1AcceptanceManifest = projection as AcceptanceManifest;
